module.exports = __webpack_public_path__ + "static/media/5_r_pecok_63.85_86.39.8beeee28.png";